import { render, staticRenderFns } from "./UsedCarDetail.vue?vue&type=template&id=1dfeec10&scoped=true&"
import script from "./UsedCarDetail.vue?vue&type=script&lang=js&"
export * from "./UsedCarDetail.vue?vue&type=script&lang=js&"
import style0 from "./UsedCarDetail.vue?vue&type=style&index=0&id=1dfeec10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfeec10",
  null
  
)

export default component.exports